import React from 'react';
import FeatherSpinner from './FeatherSpinner';

export interface ProcessLoadingCardProps {
  title: React.ReactNode;
  description?: React.ReactNode;
}

/** The shared outlined progress card; callers choose inline or overlay placement. */
const ProcessLoadingCard: React.FC<ProcessLoadingCardProps> = ({ title, description }) => (
  <div className="process-loading-card" role="status" aria-live="polite" aria-atomic="true">
    <div aria-hidden="true">
      <FeatherSpinner style={{ width: 64, height: 64 }} />
    </div>
    <div className="process-loading-copy">
      <div className="process-loading-title">{title}</div>
      {description && <div className="process-loading-subtitle">{description}</div>}
    </div>
  </div>
);

export default ProcessLoadingCard;
